import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';

const DateRangeInput = ({
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  error,
  sx,
  inputSx,
}) => {
  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ height: 40, ...sx }}>
      <TextField
        type="date"
        size="small"
        value={fromValue || ""}
        onChange={onFromChange}
        inputProps={{ "aria-label": "From date" }}
        sx={{
          width: 148,
          m: 0,
          "& .MuiInputBase-root": {
            height: 40,
          },
          ...inputSx,
        }}
      />
      <Typography variant="body2" color="text.secondary">
        ~
      </Typography>
      <TextField
        type="date"
        size="small"
        value={toValue || ""}
        onChange={onToChange}
        error={Boolean(error)}
        inputProps={{ "aria-label": "To date" }}
        sx={{
          width: 148,
          m: 0,
          "& .MuiInputBase-root": {
            height: 40,
          },
          ...inputSx,
        }}
      />
    </Stack>
  );
};

export default DateRangeInput;
